// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16m0S","newExpiryDate":"styles_newExpiryDate__UY08X","footer":"styles_footer__2yMS8"};